import './detection.less';
export default class Detection extends PF.List.Item
{

    get renderer()
    {
        //language=HTML
        return `
    		<li pf="item">
                <a href="" class=" item-content item-link" pf="link">
                    <div class="item-inner">
                        <div class="item-title">
                            @{model.startMsc} - @{model.finishMsc}<br/>
                            Стела: "@{model.camera.serverVa.name}" <br/> 
                            Камера: "@{model.camera.name}"
                    	</div>
                    	<div class="item-after detection-after">
                            <table>
                                <tr><td>
                                    <div class="img">
                                        <img src="@{model.personImgsTitle}" pf="img"><br/>
                                    </div>
                                </td><td>
                                    <span title="Максимальное качество фотографии">Качество: <br/> @{model.personImgsPercent}</span><br/>
                                    <span title="Процент совпадение с персоной">Совпадение: <br/> @{model.similarityPercent}</span>
                                </td></tr>  
                            </table>
                    	</div>
                    	<div class="item-subtitle">
                            <span pf="hasScreenViewText">@{model.hasScreenViewText}</span><br/>
                            <span pf="emotion" title="Преобладающая эмоция">@{model.emotion.name}</span>
                            <span pf="emotionPercent" title="Среднее значение преобладающей эмоции">@{model.emotionPercent}</span><br/>
                            <span pf="processText">@{model.processText}</span> 
                    	</div>
    				</div>
    			</a>
    		</li>
    	`;
    }

    get popupTemplate()
    {
        //language=HTML
        return /*html*/`
            <div style="height: 100%;">                
                               
                <div class="pf-button-toggle row resizable" pf="wrapper" style="padding-bottom: 16px">
                    <div class="segmented segmented-raised col-100" pf="ul">
                        <button class="button button-active" type="button" pf="button1">Статистика</button>
                        <!-- <button class="button" type="button" pf="button2">Файлы детекции</button> -->
                        <button class="button" type="button" pf="button3">Детали детекции</button>
                    </div>
                </div>

                <div class="content" pf="detectChart" style="height: 90%; margin:0;">

                    <div class="pf-button-toggle row resizable" pf="wrapper" style="padding-bottom: 16px">
                        <div class="segmented segmented-raised col-100" pf="ul">
                            <button class="button button-active" type="button" pf="buttonChartBlock">Общая</button>
                            <button class="button" type="button" pf="buttonChartViews">Просмотров: <b pf="infoChartViews"></b></button>
                            <button class="button" type="button" pf="buttonChartMap">Карта</button>
                        </div>
                    </div>

                    <div class="content" pf="detectChartBlock" style="height: 90%; margin:0; overflow: auto;">                        
                        <div pf="chartBlockButtons"></div>
                        <div pf="chartBlock"></div>

                        <div class="preloader-wrapper" pf="preloader" style="width: fit-content; margin: auto;">
                            <div class="preloader" style="margin:40px auto; ">
                                <span class="preloader-inner">
                                    <span class="preloader-inner-gap"></span>
                                    <span class="preloader-inner-left">
                                        <span class="preloader-inner-half-circle"></span>
                                    </span>
                                    <span class="preloader-inner-right">
                                        <span class="preloader-inner-half-circle"></span>
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="content" pf="detectChartViews" style="height: 90%; margin:0; overflow: auto;">
                        <div class="preloader-wrapper" pf="preloaderViews" style="width: fit-content; margin: auto;">
                            <div class="preloader" style="margin:40px auto; ">
                                <span class="preloader-inner">
                                    <span class="preloader-inner-gap"></span>
                                    <span class="preloader-inner-left">
                                        <span class="preloader-inner-half-circle"></span>
                                    </span>
                                    <span class="preloader-inner-right">
                                        <span class="preloader-inner-half-circle"></span>
                                    </span>
                                </span>
                            </div>
                        </div>
                        <div class="stretch-block">
                            <div pf="chartViewsBlockList" style="position: relative;"></div>
                        </div>
                    </div>

                    <div class="content" pf="detectChartMap" style="height: 90%; margin:0;">                    
                        <button style="position:absolute;z-index:10; top: 120px; left:10px; height: 40px; width: 40px" class="button button-fill" pf="zoomIn">
                            <i class="material-icons" style="line-height:40px">zoom_in</i>
                        </button>
                        <button style="position:absolute;z-index:10; top: 180px; left:10px; height: 40px; width: 40px" class="button button-fill" pf="zoomOut">
                            <i class="material-icons" style="line-height:40px">zoom_out</i>
                        </button>
                        <div style="height: 90%;" pf="map"></div>
                    </div>

                </div>
                
                <div class="content" pf="detectInfoFiles" style="height: 90%; margin:0; overflow: auto;">
                    <div pf="detectionResiduaryImgs" class="detection-files"></div>
                </div>
                
                <div class="content" pf="detectInfoData" style="height: 90%; margin:0; overflow: auto;">
                    <div class="block" style="margin-top: 0px;">  
                        <table>
                            <tr><td>id:</td><td>@{model.id}</td></tr>
                            <tr><td>Стела:</td><td>@{model.serverVa.name} | (@{model.server_va_id})</td></tr>
                            <tr><td>Камера:</td><td>@{model.camera.name} | (@{model.camera.id})</td></tr>
                            <tr><td>Преобладающая эмоция:</td><td>@{model.emotion.name}</td></tr>
                            <tr><td>Среднее значение эмоции:</td><td>@{model.emotionPercent}</td></tr>    
                            <tr><td>Начало:</td><td> @{model.start}(utc)</td></tr>
                            <tr><td>Конец:</td><td> @{model.finish}(utc)</td></tr>     
                        </table>      
                    </div>
                    <div class="pf-button-toggle row resizable" pf="wrapper" style="padding-bottom: 16px">
                        <div class="segmented segmented-raised col-100" pf="ul">
                            <!-- <button class="button" type="button" pf="buttonInfoTrack">Детальный Разбор</button> -->
                            <button class="button" type="button" pf="buttonRawTrack">Персона</button>
                        </div>
                    </div>
                    <div class="content" pf="detectInfoTrack" style="margin:0;">
                        <div class="preloader-wrapper" pf="preloaderTrack" style="width: fit-content; margin: auto;">
                            <div class="preloader" style="margin:40px auto; ">
                                <span class="preloader-inner">
                                    <span class="preloader-inner-gap"></span>
                                    <span class="preloader-inner-left">
                                        <span class="preloader-inner-half-circle"></span>
                                    </span>
                                    <span class="preloader-inner-right">
                                        <span class="preloader-inner-half-circle"></span>
                                    </span>
                                </span>
                            </div>
                        </div>
                        <div pf="trackList"></div>
                    </div>
                    <div class="content" pf="detectInfoRawTrack" style="margin:0;">
                        <div class="person-block-detect">
                            <div class="person-data">
                                <div class="img">
                                    <img src="@{model.personImgs.0.file.local_url}" pf="img"><br/>
                                </div>
                                <div class="info">
                                    UUID: <span>@{model.person_id} <br/>
                                    Максимальное качество фотографии: @{model.personImgs.0.quality}<br/>
                                    Совпадение: @{model.similarityPercent}<br/>
                                    <button class="button-fill button" pf="linkPerson">Подробнее о персоне</button>
                                </div>
                            </div>
                            <div class="block">  
                                <div pf="personImgList"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    	`;
    }

    //---------------------------------------------

    // инит детекции
    onRender()
    {
        this.model.personImgsPercent = 0;
        if (this.model.get('personImgs', null, null) !== null)
        {
            if (this.model.personImgs.count > 0)
            {
                this.model.personImgsPercent = (this.model.personImgs[0].quality * 100).toFixed(2) + " %";
            }
        }
        this.model.personImgsTitle = '';
        if (this.model.personImgs[0] !== undefined)
        {
            this.model.personImgsTitle = this.model.personImgs[0].file.local_url
        }
        super.onRender();

        this.bindDom({ processText: "css:color" }, 'model.process', (p) => p === true ? 'inherit' : 'red');
        this.bindDom({ hasScreenViewText: "css:color" }, 'model.has_screen_view', (p) => p === true ? 'green' : 'inherit');

        this.dom.link.on("click", (event) =>
        {
            if (this.popup === undefined)
            {
                app.toast("Получаем данные...");
                this.model.options.represent = 'detection/View';

                this.model.on('updated', () =>
                {
                    this.dom.load(this.popupTemplate, "popupContent");

                    this.dom.popupContent.bindObject(this);

                    this.popup = new PF.F7Popup({
                        dom: {
                            content: this.dom.popupContent
                        },
                        title: 'Детекция за ' + this.model.startMsc + " - " + this.model.finishMsc,
                    });
                    if (this.model.process === true)
                    {
                        app.toast("Получили. Обрабатываем данные...");
                        this.renderDetection();
                    } else
                    {
                        app.toast("Детекция находится в обработке!");
                    }
                    this.popup.open();
                    app.popupRect = this.popup;

                    this.loadStatus = true;
                    this.bindDom({ preloader: 'show' }, 'loadStatus');
                    this.loadStatusTrack = false;
                    this.bindDom({ preloaderTrack: 'show' }, 'loadStatusTrack');
                    this.loadStatusViews = false;
                    this.bindDom({ preloaderViews: 'show' }, 'loadStatusViews');
                    this.buttonChartViews = false;
                    this.bindDom({ buttonChartViews: 'show' }, 'buttonChartViews');

                    this.sleep(500).then(() => { this.renderChart(); });
                });

                this.model.personImgs = [];
                this.model.update();
            } else
            {
                this.popup.open();
                app.popupRect = this.popup;
            }

        })
    }

    renderDetection()
    {
        //-------------
        // Основные вкладки
        this.state = 'stat';
        this.dom.button1.on('click', () =>
        {
            this.state = 'stat';
        });
        this.filesInit = 1;
        // this.dom.button2.on('click', () =>
        // {
        //     this.state = 'files';
        //     let filesLength = 1;
        //     if (this.filesInit === 1 && this.model.emotionChart.length > 10000)
        //     {
        //         let isAdmin = confirm("Размер детекции слишком большой, всё равно попробовать просмотреть файлы?");
        //         filesLength = isAdmin ? 2 : 1
        //     } else
        //     {
        //         filesLength = 2
        //     }
        //     if (this.filesInit === 1 && filesLength === 2)
        //     {
        //         this.filesInit++;
        //         if (this.model.get('track', null, null) !== null)
        //         {
        //             app.toast("Обрабатываем...");
        //             this.detectionResiduaryImgsList = new PF.Dom.List({
        //                 dom: { element: this.dom.detectionResiduaryImgs },
        //                 enableHeader: false,
        //                 models: this.model.track,
        //                 itemClass: DetectionResiduaryImgs_V2,
        //             });
        //         } else
        //         {
        //             app.toast("Получаем данные...");
        //             this.rawTrack = new PF.Model({ represent: "detection/ViewTrack", where: `id ='${this.model.id}'`, saveOnModify: false, raw: { data: {} } });
        //             this.rawTrack.onValue('options.loadStatus', 'loaded', () =>
        //             {
        //                 app.toast("Обрабатываем...");
        //                 this.model.track = this.rawTrack.track;
        //                 this.detectionResiduaryImgsList = new PF.Dom.List({
        //                     dom: { element: this.dom.detectionResiduaryImgs },
        //                     enableHeader: false,
        //                     models: this.model.track,
        //                     itemClass: DetectionResiduaryImgs_V2,
        //                 });
        //             });
        //         }

        //     }
        // });
        this.dom.button3.on('click', () =>
        {
            this.state = 'info';
        });
        this.bindDom({ detectChart: 'show' }, 'state', (s) => s === 'stat');
        this.bindDom({ detectInfoFiles: 'show' }, 'state', (s) => s === 'files');
        this.bindDom({ detectInfoData: 'show' }, 'state', (s) => s === 'info');

        this.bindDom({ button1: 'class:button-active' }, 'state', (s) => s === 'stat');
        // this.bindDom({ button2: 'class:button-active' }, 'state', (s) => s === 'files');
        this.bindDom({ button3: 'class:button-active' }, 'state', (s) => s === 'info');
        //-------------
        //Вкладки статистики

        this.detectChart = 'Chart';
        this.dom.buttonChartBlock.on('click', () =>
        {
            this.detectChart = 'Chart';
        });
        this.viewsInit = 1;
        this.dom.buttonChartViews.on('click', () =>
        {
            this.detectChart = 'Views';
            if (this.viewsInit === 1)
            {
                this.viewsInit++;
                this.loadStatusViews = true;
                this.sleep(500).then(() => { this.renderChartViews(); });
            }
        });
        this.mapInit = 1;
        this.dom.buttonChartMap.on('click', () =>
        {
            this.detectChart = 'Map';
            let mapInitLength = 1;
            if (this.mapInit === 1 && this.model.emotionChart.length > 10000)
            {
                let isAdmin = confirm("Размер детекции слишком большой, всё равно попробовать открыть карту?");
                mapInitLength = isAdmin ? 2 : 1
            } else
            {
                mapInitLength = 2
            }

            if (this.mapInit === 1 && mapInitLength === 2)
            {
                this.mapInit++;
                if (this.model.get('track', null, null) !== null)
                {
                    ymaps.ready(() => this.renderScene());
                } else
                {
                    app.toast('Получаем данные...');
                    this.rawTrack = new PF.Model({ represent: "detection/ViewTrack", where: `id ='${this.model.id}'`, saveOnModify: true, raw: { data: {} } });
                    this.rawTrack.onValue('options.loadStatus', 'loaded', () =>
                    {
                        this.model.track = this.rawTrack.track;
                        ymaps.ready(() => this.renderScene());
                    });
                }
            }
        });

        this.bindDom({ detectChartBlock: 'show' }, 'detectChart', (s) => s === 'Chart');
        this.bindDom({ detectChartMap: 'show' }, 'detectChart', (s) => s === 'Map');
        this.bindDom({ detectChartViews: 'show' }, 'detectChart', (s) => s === 'Views');

        this.bindDom({ buttonChartBlock: 'class:button-active' }, 'detectChart', (s) => s === 'Chart');
        this.bindDom({ buttonChartMap: 'class:button-active' }, 'detectChart', (s) => s === 'Map');
        this.bindDom({ buttonChartViews: 'class:button-active' }, 'detectChart', (s) => s === 'Views');

        //-------------
        //Вкладки деталей детекций

        this.trackInfo = 'info2';
        this.trackInit = 1;
        // this.dom.buttonInfoTrack.on('click', () =>
        // {
        //     this.trackInfo = 'info';
        //     let trackLength = 1;
        //     if (this.trackInit === 1 && this.model.emotionChart.length > 10000)
        //     {
        //         let isAdmin = confirm("Размер детекции слишком большой, всё равно попробовать просмотреть обзор?");
        //         trackLength = isAdmin ? 2 : 1
        //         this.loadStatusTrack = isAdmin ? true : false;
        //     } else
        //     {
        //         trackLength = 2
        //     }
        //     if (this.trackInit === 1 && trackLength === 2)
        //     {
        //         this.loadStatusTrack = true;
        //         this.trackInit++;
        //         this.sleep(1000).then(() => { this.renderTrackInit(); });
        //     }
        // });
        this.dom.buttonRawTrack.on('click', () =>
        {
            this.trackInfo = 'raw';
        });
        // this.bindDom({ detectInfoTrack: 'show', detectInfoRawTrack: 'hide' }, 'trackInfo', (s) => s === 'info');
        this.bindDom({ detectInfoTrack: 'show' }, 'trackInfo', (s) => s === 'info');
        this.bindDom({ detectInfoRawTrack: 'show' }, 'trackInfo', (s) => s === 'raw');
        // this.bindDom({ buttonInfoTrack: 'class:button-active' }, 'trackInfo', (s) => s === 'info');
        this.bindDom({ buttonRawTrack: 'class:button-active' }, 'trackInfo', (s) => s === 'raw');

        //-------------
        // список фоток персоны детекции
        if (this.model.get('personImgs', null, null) !== null)
        {
            if (this.model.personImgs.count > 0)
            {
                this.personImgList = new PF.List({
                    dom: {
                        element: this.dom.personImgList,
                    },
                    searchable: false,
                    models: this.model.personImgs,
                    description: this.model.description,
                    itemClass: PersonImgs,
                });
            }
        }

        this.linkPerson();
    }

    //---------------------------------------------

    linkPerson()
    {
        this.dom.linkPerson.on("click", () =>
        {
            app.pageParams.setData('id', this.model.person_id);
            app.pageParams.setData('similarity', this.model.similarity);
            app.pageParams.setData('return', 'detections');
            app.popupRect = null;
            this.popup.close();
            app.router.navigate('/stat-person');
        });
    }

    //---------------------------------------------

    renderChart() 
    {
        console.log("emotion init");
        try
        {
            if (this.model.screenViewsCount > 0)
            {
                this.buttonChartViews = true;
                this.dom.infoChartViews.bindHtml();
                this.dom.infoChartViews.html = " " + this.model.screenViewsCount;
            }
            this.emotionChartInit();
            this.loadStatus = false;
        } catch (e)
        {
            this.loadStatus = false;
            console.log("emotion init error", e);
        }
    }

    /**
     * Общая статистика(Основной график)
     */
    emotionChartInit()
    {
        this.dom.chartBlockButtons.empty();

        console.log(this.model.emotionChart);
        // если данных меньше минимума, показать всё
        if (this.model.emotionChart.count === 1)
        {
            this.emotionChart(this.model.emotionCharts[0]);
        } else
        {
            let config = [];
            for (let index = 0; index < this.model.emotionCharts.length; index++)
            {
                config[index] = {
                    id: index,
                    name: index + 1
                }
            }
            this.last_index = config.length;
            this.chartButtons = new PF.Field.ButtonsToggle({
                dom: { element: this.dom.chartBlockButtons },
                listConfig: {
                    modelsConfig: {
                        raw: config
                    }
                },
            })
            this.chartButtons.onChange('selected', () =>
            {
                this.loadStatus = true;
                this.emotionChart(this.model.emotionCharts[this.chartButtons.selected.index]);
            }, true);
        }

    } // emotionChartInit

    emotionChart(emotionCharts)
    {
        this.dom.chartBlock.empty();
        this.chartBlock = new PF.Charts.Highcharts({
            dom: { element: this.dom.chartBlock },
            title: {
                text: `Показатели эмоций c ${emotionCharts.start} по ${emotionCharts.finish}`,
            },
            subtitle: {
                text: `Детекция за ${this.model.startMsc} - ${this.model.finishMsc}`,
            },
            xAxis: {
                categories: emotionCharts.x,
                labels: { format: '{value}' }
            },
            yAxis: {
                min: 0,
                max: 100,
                title: { text: '%' }
            },
            legend: {
                align: 'left',
            },
            series: emotionCharts.series,
            plotOptions: {
                area: {
                    pointStart: 1940,
                    marker: {
                        enabled: false,
                        symbol: 'circle',
                        radius: 2,
                        states: {
                            hover: {
                                enabled: true
                            }
                        }
                    }
                }
            },
        });
        this.loadStatus = false;
    } // creatEmotionChart

    /**
     * Статистика просмотров
     */
    renderChartViews() 
    {
        try
        {
            this.dom.chartViewsBlockList.empty();
            if (this.model.screenViewsCount > 0)
            {
                if (this.model.screenViewsCount < 5)
                {
                    app.toast("Обрабатываем...");
                    this.screenViewsList = new PF.Dom.List({
                        dom: { element: this.dom.chartViewsBlockList },
                        enableHeader: false,
                        models: this.model.screenViews,
                        itemClass: ScreenView,
                    })
                    this.loadStatusViews = false;
                } else
                {
                    app.toast("Получаем данные...");
                    console.log(this.model.screenViewsCount);
                    this.screenViewsList = new PF.List({
                        dom: {
                            scrollTarget: this.dom.detectChartViews,
                            element: this.dom.chartViewsBlockList
                        },
                        enableHeader: false,
                        modelsConfig: {
                            represent: 'detection/ViewChartScreenViews',
                            limit: 3,
                            where: `detection_id ='${this.model.id}'`,
                        },
                        itemClass: ScreenView,
                    })
                    this.loadStatusViews = false;
                }
            }
        } catch (e)
        {
            console.log("emotion init error");
        }
    } // renderChartViews

    //---------------------------------------------

    /**
     * Рендер карты по необходимости
     */
    renderScene()
    {
        try
        {
            this.map = new ymaps.Map(this.dom.map.node, {
                center: app.mapConfig.defaultCenter,
                zoom: 21,
                // ...app.mapConfig
                controls: ['fullscreenControl', 'typeSelector', 'geolocationControl', 'rulerControl'],
                // controls: []
            }, {
                maxZoom: 23
            });
            this.dom.zoomIn.on('click', () =>
            {
                this.map.setZoom(this.map.getZoom() + 1);
            });
            this.dom.zoomOut.on('click', () =>
            {
                this.map.setZoom(this.map.getZoom() - 1);
            });

            this.camerasList = new PF.Map.PointsList({
                map: this.map,
                models: this.model.camera.scene.config.cameras,
                itemClass: Camera,
            });
            this.screensList = new PF.Map.PointsList({
                map: this.map,
                models: this.model.camera.scene.config.screens,
                itemClass: Screen,
            });

            this.detectionLine = new PF.Map.Polyline({
                map: this.map,
                models: this.model.track,
                pathToCord: "geoCords",
                polylineProperties: {
                    hintContent: "Трек"
                },
                polylineOptions: {
                    strokeColor: '#0000ff88',
                    strokeWidth: 7,
                    zIndex: 20,
                    zIndexHover: 20,
                }
            });

            let cameraConfig;
            for (let i = 0; i < this.model.camera.scene.config.cameras.length; i++)
            {
                if (this.model.camera.id == this.model.camera.scene.config.cameras[i].id)
                {
                    cameraConfig = this.model.camera.scene.config.cameras[i].config;
                    break;
                }
            }

            let pointCamera = [cameraConfig.cords.lat, cameraConfig.cords.lng];
            let yaw = cameraConfig.angle.yaw;

            this.viewPointsPolygon = [];
            for (let j = 0; j < this.model.track.length; j++)
            {
                let poinFace = this.model.track[j].geoCords;
                let azimutCamera_d = ymaps.coordSystem.geo.solveInverseProblem(poinFace, pointCamera).startDirection;
                let azimutCamera = Math.atan2(azimutCamera_d[1], azimutCamera_d[0]) * (180 / Math.PI);
                let azimutFace = azimutCamera - this.radToDeg(this.model.track[j].angle.yaw);
                let angle_1 = azimutFace - yaw;
                let angle_2 = azimutFace + yaw;

                let direction1 = [Math.cos(angle_1 * (Math.PI / 180)), Math.sin(angle_1 * (Math.PI / 180))];
                let direction2 = [Math.cos(angle_2 * (Math.PI / 180)), Math.sin(angle_2 * (Math.PI / 180))];

                let poinFaceView1 = ymaps.coordSystem.geo.solveDirectProblem(poinFace, direction1, 2).endPoint;
                let poinFaceView2 = ymaps.coordSystem.geo.solveDirectProblem(poinFace, direction2, 2).endPoint;

                this.viewPointsPolygon[j] = new PF.Map.Polygon({
                    map: this.map,
                    models: new PF.Models({
                        raw: [
                            poinFace,
                            poinFaceView1,
                            poinFaceView2
                        ]
                    }),
                    polygonProperties: {
                        hintContent: 'Направление головы в ' + this.model.track[j].time
                    },
                    polygonOptions: {
                        fillColor: '#00FF0006',
                        strokeColor: '#0000FF22',
                        strokeWidth: 3,
                        zIndex: 25,
                        zIndexHover: 25,
                    }
                });
            }

            this.map.setBounds(this.map.geoObjects.getBounds(), { checkZoomRange: true }).then(function () { });

            this.screenViewsTracks = [];
            if (this.model.screenViewsCount > 0)
            {
                if (this.model.screenViewsCount < 5)
                {
                    for (let i = 0; i < this.model.screenViews.length; i++)
                    {
                        this.screenViewsTracks[i] = new PF.Map.Polyline({
                            map: this.map,
                            models: this.model.screenViews[i].track,
                            pathToCord: "geoCords",
                            polylineProperties: {
                                hintContent: "Трек c просмотром"
                            },
                            polylineOptions: {
                                strokeColor: '#ffff00ff',
                                strokeWidth: 3,
                                zIndex: 30,
                                zIndexHover: 30,
                            }
                        });
                    }
                } else
                {
                    app.toast('Получаем данные...');
                    this.rawScreenViews = new PF.Model({ represent: "detection/ViewScreenViews", where: `id ='${this.model.id}'`, saveOnModify: true, raw: { data: {} } });
                    this.rawScreenViews.onValue('options.loadStatus', 'loaded', () =>
                    {
                        this.model.screenViews = this.rawScreenViews.screenViews;
                        for (let i = 0; i < this.model.screenViews.length; i++)
                        {
                            this.screenViewsTracks[i] = new PF.Map.Polyline({
                                map: this.map,
                                models: this.model.screenViews[i].track,
                                pathToCord: "geoCords",
                                polylineProperties: {
                                    hintContent: "Трек c просмотром"
                                },
                                polylineOptions: {
                                    strokeColor: '#ffff00ff',
                                    strokeWidth: 3,
                                    zIndex: 30,
                                    zIndexHover: 30,
                                }
                            });
                        }
                    });
                }
            }
        } catch (e)
        {
            console.log("map init error");
        }

    }

    /**
     * Преобразовывает радианы в градусы
     * @param {*} rad 
     * @returns 
     */
    radToDeg(rad)
    {
        return (rad * 180) / Math.PI;
    }

    //---------------------------------------------

    /**
     * детализация трека по необходимость
     */
    renderTrackInit()
    {
        let config = {};
        for (let index = 0; index < this.model.camera.scene.config.cameras.length; index++)
        {
            if (this.model.camera_id = this.model.camera.scene.config.cameras[index].id)
            {
                config = this.model.camera.scene.config.cameras[index].config.angle.toJSON();
            }
        }

        if (this.model.get('track', null, null) !== null)
        {
            this.track = new PF.Models({
                raw: this.model.track.toJSON()
            });
            this.renderTrack(config);
        } else
        {
            app.toast('Получаем данные...');
            this.rawTrack = new PF.Model({ represent: "detection/ViewTrack", where: `id ='${this.model.id}'`, saveOnModify: false, raw: { data: {} } });
            this.rawTrack.onValue('options.loadStatus', 'loaded', () =>
            {
                this.model.track = this.rawTrack.track;
                this.loadStatusTrack = true;
                this.track = new PF.Models({
                    raw: this.model.track.toJSON()
                });
                this.renderTrack(config);
            });
        }
    } // renderTrackInit

    renderTrack(config)
    {
        app.toast('Начался процесс анализа трека<br>Пожалуйста подождите');
        this.trackPointList = new PF.List({
            dom: {
                element: this.dom.trackList,
            },
            searchable: false,
            imgs: this.model.detectionImgs,
            camera: this.model.camera_id,
            count: 0,
            config: config,
            models: this.track,
            itemClass: TrackPoint,
        });

        this.loadStatusTrack = false;
    } // renderTrack

    //---------------------------------------------

    //https://active-vision.ru/blog/js-settimout-i-sleep-v-javascript/
    sleep(ms)
    {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
}

class PersonImgs extends PF.Dom.List.Item
{
    get renderer()
    {
        //language=HTML
        return `
            <div class="item-inner">
                <div class="item-title">
                    <img src="@{model.file.local_url}" alt="@{model.dt}" title="@{model.dt}" style="width: 100px;">
                </div>
                <div class="item-after">
                
                </div>
                <div class="item-subtitle"">
                    Качество: @{model.quality}
                    @{model.person}
                </div>
            </div>
    	`;
    }

    onRender()
    {
        this.model.person = ``;
        if (this.list.description)
        {
            let persons_id = Object.keys(this.list.description);
            for (let i = 0; i < persons_id.length; i++)
            {
                if (persons_id[i] != 'options')
                {
                    let person = this.list.description[persons_id[i]];
                    if (person.quality.toFixed(7) == this.model.quality.toFixed(7))
                    {
                        this.model.person = `<br>Возраст: ${person.age}<br>Пол: ${person.gender}<br>`;
                    }
                }
            }
        }

        //----
        super.onRender();
    }
}

class TrackPoint extends PF.Dom.List.Item
{
    get renderer()
    {
        //language=HTML
        return `
            <div class="item-inner">
                <div class="item-title" style="min-height: 220px;">
                    Время: @{model.time} (UTC)<br>
                    Качество: @{model.file.quality}<br>
                    <table>
                        <tr><th>angle</th><th>rad</th><th>deg</th><th>Допустимо</th></tr>
                        <tr><td>pitch</td><td>@{model.angle.pitch}</td><td>${this.radToDeg(this.model.angle.pitch)}</td><td>±${this.list.config.pitch}</td></tr>
                        <tr><td>yaw</td><td>@{model.angle.yaw}</td><td>${this.radToDeg(this.model.angle.yaw)}</td><td>±${this.list.config.yaw}</td></tr>
                        <tr><td>roll</td><td>@{model.angle.roll}</td><td>${this.radToDeg(this.model.angle.roll)}</td><td>-</td></tr>
                    </table>
                  <!--  <div pf="chartBlockEmotion"  style="height: 180px; width: 400px"></div> -->
                </div>
                <div class="item-after">
                    <div class="container-cube">
                        <div pf="cube" class="cube" style=" transform: rotateX(${this.radToDeg(this.model.angle.pitch)}deg) rotatez(${this.radToDeg(this.model.angle.roll)}deg) rotatey(${this.radToDeg(this.model.angle.yaw)}deg);">
                            <span class="front" pf="front">1</span>
                            <span class="back">2</span>
                            <span class="top">3</span>
                            <span class="bottom">4</span>
                            <span class="left">5</span>
                            <span class="right">6</span>
                        </div>
                    </div>
                </div>
                <div class="item-subtitle" style="min-width: 110px;">
                    <img src="@{model.img.local_url}" alt="@{model.dt}" title="@{model.dt}" style="width: 100px;">
                </div>
            </div>
    	`;
    }

    onRender()
    {
        //----
        super.onRender();
        // console.log(this.model, this.list.imgs[0]);
        this.bindDom({ cube: 'css:background-color' }, '#4e6473');

        this.state = 'def';
        if (
            parseFloat(this.radToDeg(this.model.angle.pitch)) >= -this.list.config.pitch &&
            parseFloat(this.radToDeg(this.model.angle.pitch)) <= this.list.config.pitch
        )
        {
            if (
                parseFloat(this.radToDeg(this.model.angle.yaw)) >= -this.list.config.yaw &&
                parseFloat(this.radToDeg(this.model.angle.yaw)) <= this.list.config.yaw
            )
            {
                this.state = 'yes'
            }
        }
        this.bindDom({ front: 'class:front' }, 'state', (s) => s === 'def');
        this.bindDom({ front: 'class:front-y' }, 'state', (s) => s === 'yes');
    }

    radToDeg(rad)
    {
        return ((rad * 180) / Math.PI).toFixed(2);
    }
}

class ScreenView extends PF.Dom.List.Item
{
    get renderer()
    {
        //language=HTML
        return /*html*/`
            <div class="screen-view">
                <p class="screen-view-title">@{screenViewTitle}</p>
                <div class="screen-view-block">
                    <div class="chart" pf="screenViewChart"></div>
                    <!-- <div class="imgs" pf="screenViewImg"></div> -->
                </div>
    		</div>
    	`;
    }

    onRender()
    {
        this.screenViewTitle = "Просмотр экрана с " + this.model.start + " по " + this.model.finish;
        super.onRender();
        this.screenViewChart = new PF.Charts.Highcharts({
            dom: { element: this.dom.screenViewChart },
            title: "Показатели эмоций",
            xAxis: {
                categories: this.model.emotionChart.x,
                labels: { format: '{value}' }
            },
            yAxis: {
                min: 0,
                max: 100,
                title: { text: '%' }
            },
            series: this.model.emotionChart.series.toJSON(),
            plotOptions: {
                area: {
                    pointStart: 1940,
                    marker: {
                        enabled: false,
                        symbol: 'circle',
                        radius: 2,
                        states: {
                            hover: {
                                enabled: true
                            }
                        }
                    }
                },
                series: {
                    marker: {
                        enabled: true,
                        radius: 2,
                        states: {
                            hover: {
                                enabled: false
                            },
                            select: {
                                enabled: true,
                                radius: 5
                            }
                        }
                    }
                }
            },
        });

        // this.screenViewsImgsList = new PF.Dom.List({
        //     dom: { element: this.dom.screenViewImg },
        //     enableHeader: false,
        //     models: this.model.track,
        //     itemClass: ScreenViewImg,
        //     screenViewChart: this.screenViewChart
        // })
    }
}

class ScreenViewImg extends PF.Dom.List.Item
{
    get renderer()
    {
        //language=HTML
        return `
            <div class="img" pf="img">
                <img src="@{model.img.local_url}" alt="@{model.time}" title="@{model.time}">
    		</div>
    	`;
    }
}

class DetectionResiduaryImgs_V2 extends PF.Dom.List.Item
{
    get renderer()
    {
        //language=HTML
        return `
            <div class="img" pf="img">
                <img src="@{model.img.local_url}" alt="@{model.dt}" title="@{model.dt}">
    		</div>
    	`;
    }
}

class Camera extends PF.Map.PointsList.Item
{
    onRender()
    {
        this.cameraPoint = new ymaps.Placemark(
            [this.model.config.cords.lat, this.model.config.cords.lng], {
            hintContent: 'Камера: ' + this.model.name,
        }, {
            preset: 'islands#grayVideoCircleIcon',
            iconImageSize: [15, 20],
            draggable: false,
            zIndex: 10,
            zIndexHover: 10,
        }
        );
        this.list.map.geoObjects.add(this.cameraPoint);

        this.viewPointsPolygon = new PF.Map.Polygon({
            map: this.list.map,
            models: this.model.config.viewPoints,
            polygonProperties: {
                hintContent: 'Обзор камеры ' + this.model.name
            },
            polygonOptions: {
                fillColor: '#00FF0011',
                strokeColor: '#0000FF22',
                strokeWidth: 3
            }
        });
    }
}

class Screen extends PF.Map.PointsList.Item
{
    onRender()
    {
        this.polyline = new ymaps.Polyline([
            this.model.config.p1, [this.model.config.centerCords.lat, this.model.config.centerCords.lng], this.model.config.p2
        ], {
            hintContent: 'Экран: ' + this.model.name,
        }, {
            strokeColor: "#000000",
            strokeWidth: 4,
            strokeOpacity: 0.5,
            draggable: false,
        });


        this.pc = new ymaps.Placemark(
            [this.model.config.centerCords.lat, this.model.config.centerCords.lng], {
            hintContent: 'Направление: ' + this.model.name,
        }, {
            iconRotate: 0,
            // iconLayout: 'default#image',
            iconImageHref: '/img/ico/arrow.png',
            iconImageSize: [20, 20],
            iconImageOffset: [-10, -10],
            draggable: true,
            iconLayout: ymaps.templateLayoutFactory.createClass(
                `<div id="${this.centerId}" style="transform:rotate(${this.model.config.orientation}deg);">
                {% include "default#image" %}
                </div>`
            ),
        });

        this.list.map.geoObjects.add(this.polyline);
        this.list.map.geoObjects.add(this.pc);
    }
}